---
en:
  power_plants:
    asset_class_types:
      all: ALL
      bilateral/asset: Bilateral
      hydro/asset: Hydro
      solar/asset: Solar
      wind/asset: Wind
    bell:
      link_ok: Link is OK
      no_link: No link
    bilateral_capacity_hint: Installed capacity for this bilateral power plant
    capacity_hint: Managed by editing producing component
    change_selection: Change the power plant selection
    chart_load:
      categories:
      - No production
      - L (25%)
      - M (25% - 75%)
      - H (> 75%)
      last_month: Last month
      subtitle: "% of time, hour-by-hour"
      this_month: This month
      title: Load
    chart_meteogram_title: 48 hour forecast
    commercial_details: Commercial details
    commissioning_date_hint: First day of operation
    deviation: Deviation
    edit_heading: Edit power plant information
    edit_notice: Contact staff if restricted fields needs to be changed
    effect_hint: Managed by editing producing component
    elcert_count: No. of elcerts
    environmental_flow_breakpoints: Environmental flow
    errors:
      different_source: Must be different from settled volume source
      missing_attribute: Missing %{attribute}
      shadow_excludes_unscaled_contract: cannot be enabled while a feed-in-tariff or hedging contract is attached, as those contracts have no ownership share to split shared production
      shadow_requires_canonical: must match the metering point of an existing non-shadow power plant
    est_downtime_cost: Est. downtime cost
    est_production: Est. production
    est_tech_downtime: Est. tech. downtime
    export_xlsx: Export to Excel
    financial_settlement: Financial settlement
    generator: Generator
    go_count: No. of GoOs
    intake: Intake
    intakes: Intakes
    kpi_monthly: Monthly performance
    measure_theor_production: Overview - measured vs. forecasted production
    measured_power: Measured power
    model_params:
      empty: No model parameters available.
      nve_fallback_hint: Using NVE value (override by entering a value)
      production_min_runtime_hours_hint: Only used by deterministic_2step. Blank = the API default of 24 h. Must fit within the optimization horizon (periods × segments, 168 h by default), or the minimum is never committed from idle.
      startup_override_placeholder: Enter production values
    monthly_production: Monthly overview - measured vs. forecasted production
    nve_info: NVE info
    of_ytd_avg: of YTD average
    of_ytd_budget: of YTD budget
    penstock: Penstock
    power_curve: Power curve
    power_plant_age: Power plant age
    precipitation_field: Precipitation field
    price_prod_history: Price and production history
    prod_bud_by_month: Production vs. budget by month
    prod_by_month: Production by month
    prod_sales_data: Production and sales data
    reservoir: Reservoir
    rev_bud_by_month: Revenue vs. budget by month
    rev_by_month: Revenue by month
    river: River
    runoff_avg: Avg. runoff
    runoff_ytd: Runoff YTD
    select_day: Select day of month
    select_month: Select month
    shadow_source_hint: Copies the selected plant's metering point ID into the field above
    shadow_source_label: Copy metering point from plant
    solar_inverter_production: Normalised inverters daily production [kWh/kWp]
    solar_kpi_epi: Energy Performance Index
    solar_kpi_pr: Performance Ratio
    solar_kpi_system_losses: System losses
    spider_categories:
    - Full load hours (%)
    - Realized price vs spot price
    - Operational hours total
    - Operational hours night
    - Theoretical production vs normal production
    - Runoff vs normal
    spot_price: Spot price
    spot_revenue: Spot revenue
    starts_stops: Starts/stops
    substation: Substation
    supplier_add: Add supplier
    supplier_form_title: Suppliers
    theoretical_power: Theoretical power
    tooltips:
      continuous_forecast_enabled: Resubmits the day-ahead production forecast whenever new Meteomatics weather data arrives (wind/solar plants).<br>Requires Forecast query and Day-ahead forecast.
      day_ahead_forecast_enabled: Submits the day-ahead production forecast (15-minute resolution) to Kaia Trade for wind/solar plants on the hourly 07:20–11:20 schedule.<br>Requires Forecast query.
      forecast_query_enabled: Master switch for outbound submissions to Kaia Trade.<br>When on, the hourly 07:20–11:20 job (and the continuous weather poller) submits whatever the toggles below enable&#58; production plans, day-ahead forecasts, and price-dependent bids.<br>Disabling halts all submissions for this plant.
      production_simulation_plan_enabled: Runs the production simulation locally every hour from 07:10 to 11:10 and stores the resulting plan.<br>The plan is then submitted to Kaia Trade by the matching job between 07:20 and 11:20 — that submission also requires Forecast query, a Kaia UUID, and Shadow testing off.<br>Returned accepted/rejected statuses are stored on each plan item.
      shadow_testing: Shadow testing mode — queries the production scheduling API but does not send anything to Trade (Kaia).<br>Use this to test production scheduling without affecting market submissions.
      use_price_dependent_bid: Submits a price-dependent bid curve to Kaia Trade on the hourly 07:20–11:20 schedule, using market prices and plant economics.<br>Requires Forecast query and a Market parameter with bidding enabled on this plant.
    tot_power_rev: Tot. Power revenue
    total_hours: Total hours
    total_revenue: Total revenue
    total_sales: Total sales
    transformer: Transformer
    turbine: Turbine
    turbine_types:
      bulb: Bulb
      francis: Francis
      kaplan: Kaplan
      lawaczeck: Lawaczeck
      ossberger: Ossberger
      pelton: Pelton
      pump: Pump
      turgo: Turgo
    unconfirmed: Estimated / unconfirmed numbers
    water_icon:
      alert: Alert on water level
      normal: Normal water level
      overflow: Overflow
      underflow: Underflow
      update: No recent data
    wind_kpi_eb_availability: Energy based availability
    wind_kpi_eb_losses: Energy losses
    wind_rose: Wind rose
